var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "breach"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('sla.inbound'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.loadBreachreasonapage('inbound')
      }
    }
  }, [(_vm.Status == 'inbound') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "drid",
      "placeholder": ('DR ID')
    },
    model: {
      value: (_vm.drid),
      callback: function($$v) {
        _vm.drid = $$v
      },
      expression: "drid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.poid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "poid",
      "placeholder": ('PO ID')
    },
    model: {
      value: (_vm.poid),
      callback: function($$v) {
        _vm.poid = $$v
      },
      expression: "poid"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breachreason),
      expression: "breachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "breachreason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.breachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                  " + _vm._s(reason.breachreason))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "drcreation"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "drcreation")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(1)
      },
      "__c": function($event) {
        _vm.type = "drcreation"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.drcreationdate')) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "sladatetime"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "sladatetime")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(2)
      },
      "__c": function($event) {
        _vm.type = "sladatetime"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.slabreachdate')) + " "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.type == 'drcreation' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'drcreation' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.slabreachsearch(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v("\n                 "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.reset')))])])])])])], 1)], 1)])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.outbound')
    },
    on: {
      "click": function($event) {
        _vm.loadBreachreasonapage('outbound')
      }
    }
  }, [(_vm.Status == 'outbound') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "orderid",
      "placeholder": ('Order ID')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breachreason),
      expression: "breachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "breachreason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.breachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                    " + _vm._s(reason.breachreason))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "ordercreation"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "ordercreation")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(1)
      },
      "__c": function($event) {
        _vm.type = "ordercreation"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.ordercreationdate')) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "sladatetime"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "sladatetime")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(1)
      },
      "__c": function($event) {
        _vm.type = "sladatetime"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.slabreachdate')) + " "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.type == 'ordercreation' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'ordercreation' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.slabreachsearch(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v("\n                   "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.reset')))])])])])])], 1)], 1)])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('config.returns')
    },
    on: {
      "click": function($event) {
        _vm.loadBreachreasonapage('returns')
      }
    }
  }, [(_vm.Status == 'returns') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.returntype')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returntype),
      expression: "returntype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "returntype",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.returntype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.returntype')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO"
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SR"
    }
  }, [_vm._v("RVP")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.awbno')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "awbno",
      "placeholder": ('AWB NO')
    },
    model: {
      value: (_vm.awbno),
      callback: function($$v) {
        _vm.awbno = $$v
      },
      expression: "awbno"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "orderid",
      "placeholder": ('Order ID')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breachreason),
      expression: "breachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "breachreason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.breachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                      " + _vm._s(reason.breachreason))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "whinscandate"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "whinscandate")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(1)
      },
      "__c": function($event) {
        _vm.type = "whinscandate"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.whinscandate')) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "datetime",
      "value": "sladatetime"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "sladatetime")
    },
    on: {
      "change": function($event) {
        _vm.datetimechange(1)
      },
      "__c": function($event) {
        _vm.type = "sladatetime"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('slaBreachReport.slabreachdate')) + " "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.type == 'whinscandate' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'whinscandate' || _vm.type == 'sladatetime') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.slabreachsearch(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v("\n                     "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.reset')))])])])])])], 1)], 1)])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s2 o1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('slaBreachReport.slabreachreport')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 s2 o2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 s1 o3"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.resultCount > 0 && _vm.downloadButtonFlag == true) ? _c('div', {
    staticClass: "col-md-2 s1 o4"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 csvbtn"
  }, [_c('span', [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.slabreachsearch(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4 xlsbtn"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), (_vm.Status == 'inbound') ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardtable cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.poid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drcreationdateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drclosedateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachby')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.actions')))])])])]), _vm._v(" "), _c('tbody', [(_vm.checkclient == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.checkwarehouse == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectWarehouseFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slabreachreasonlist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.invreferenceid) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pono))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.sladatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.closeddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((data.breachby)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.breachreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View SLA Breach Details"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewbreachreasons(data)
        }
      }
    }), _vm._v(" "), (data.breachreason === null) ? _c('i', {
      staticClass: "fa fa-plus-square-o fa-lg mt-3 ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Add Breach reason"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updatebreachreasons(data)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.clientid != '' && _vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.slabreachreasonlist.length > 0 && _vm.Status == 'inbound') ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": Number(_vm.totalRows),
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.Status == 'outbound') ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardtable cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.ordercreationdateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderdispatchdateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachby')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.actions')))])])])]), _vm._v(" "), _c('tbody', [(_vm.checkclient == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.checkwarehouse == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectWarehouseFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slabreachreasonlist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.poid) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.linecreateddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.sladatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.orderdispatchdatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((data.breachby)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.breachreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View SLA Breach Details"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewbreachreasons(data)
        }
      }
    }), _vm._v(" "), (data.breachreason == null) ? _c('i', {
      staticClass: "fa fa-plus-square-o fa-lg mt-3 ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Add Breach reason"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updatebreachreasons(data)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.clientid != '' && _vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.slabreachreasonlist.length > 0 && _vm.Status == 'outbound') ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": Number(_vm.totalRows),
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.Status == 'returns') ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardtable cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.returntype')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.awbno')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.whinscandateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.putawaydateandtime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachby')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('slaBreachReport.actions')))])])])]), _vm._v(" "), _c('tbody', [(_vm.checkclient == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.checkwarehouse == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectWarehouseFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.checkclient == true && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.orderPlaceHolder')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.slabreachreasonlist), function(data) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(data.returnstype) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.inscandatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.sladatetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(data.putawaydate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((data.breachby)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.breachreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View SLA Breach Details"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.viewbreachreasons(data)
        }
      }
    }), _vm._v(" "), (data.breachreason == null) ? _c('i', {
      staticClass: "fa fa-plus-square-o fa-lg mt-3 ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Add Breach reason"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.updatebreachreasons(data)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.clientid != '' && this.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.slabreachreasonlist.length > 0 && _vm.Status == 'returns') ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": Number(_vm.totalRows),
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.Status == 'inbound') ? _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.addbreachreasonmodal = false
      }
    },
    model: {
      value: (_vm.addbreachreasonmodal),
      callback: function($$v) {
        _vm.addbreachreasonmodal = $$v
      },
      expression: "addbreachreasonmodal"
    }
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.categoryaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.addbreachreason')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.breachreasondetails')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drid')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsourceid),
      expression: "addmodalsourceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('DR ID'),
      "name": "addmodalsourceid",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsourceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsourceid = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.poid')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalpoid),
      expression: "addmodalpoid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('PO ID'),
      "name": "addmodalpoid",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalpoid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalpoid = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.drcreationdate')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodaldrcreation),
      expression: "addmodaldrcreation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('DR Creation date'),
      "name": "addmodaldrcreation",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodaldrcreation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodaldrcreation = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladatetime')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsladatetime),
      expression: "addmodalsladatetime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('DR Close date'),
      "name": "addmodalsladatetime",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsladatetime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsladatetime = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalbreachreason),
      expression: "addmodalbreachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "addmodalbreachreason",
      "placeholder": _vm.addmodalbreachreason ? '' : 'Breach Reason'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addmodalbreachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                      " + _vm._s(reason.breachreason))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.comments')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-window-maximize'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalcomments),
      expression: "addmodalcomments"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.addmodalcomments ? null : 'Comments',
      "name": "addmodalcomments",
      "autocomplete": "nope"
    },
    domProps: {
      "value": (_vm.addmodalcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalcomments = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [(_vm.categoryaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.addbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.editbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.updateBtn')))]) : _vm._e(), _vm._v(" "), _vm._v("\n               "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])], 1)])]) : _vm._e()], 1), _vm._v(" "), (_vm.Status == 'outbound') ? _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.addbreachreasonmodal = false
      }
    },
    model: {
      value: (_vm.addbreachreasonmodal),
      callback: function($$v) {
        _vm.addbreachreasonmodal = $$v
      },
      expression: "addbreachreasonmodal"
    }
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.categoryaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.addbreachreason')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.breachreasondetails')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsourceid),
      expression: "addmodalsourceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('DR ID'),
      "name": "addmodalsourceid",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsourceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsourceid = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.ordercreationdate')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalordercreation),
      expression: "addmodalordercreation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('Order Creation date'),
      "name": "addmodalordercreation",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalordercreation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalordercreation = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladatetime')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsladatetime),
      expression: "addmodalsladatetime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('SLA date'),
      "name": "addmodalsladatetime",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsladatetime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsladatetime = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalbreachreason),
      expression: "addmodalbreachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "addmodalbreachreason",
      "placeholder": _vm.addmodalbreachreason ? '' : 'Breach Reason'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addmodalbreachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                    " + _vm._s(reason.breachreason))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.comments')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-window-maximize'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalcomments),
      expression: "addmodalcomments"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.addmodalcomments ? null : 'Comments',
      "name": "addmodalcomments",
      "autocomplete": "nope"
    },
    domProps: {
      "value": (_vm.addmodalcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalcomments = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [(_vm.categoryaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.addbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.editbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.updateBtn')))]) : _vm._e(), _vm._v(" "), _vm._v("\n             "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Status == 'returns') ? _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.addbreachreasonmodal = false
      }
    },
    model: {
      value: (_vm.addbreachreasonmodal),
      callback: function($$v) {
        _vm.addbreachreasonmodal = $$v
      },
      expression: "addbreachreasonmodal"
    }
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.categoryaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.addbreachreason')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('slaBreachReport.breachreasondetails')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.orderid')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsourceid),
      expression: "addmodalsourceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('ORDER ID'),
      "name": "addmodalsourceid",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsourceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsourceid = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.awbno')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalawbno),
      expression: "addmodalawbno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('AWB NO'),
      "name": "addmodalawbno",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalawbno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalawbno = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.whinscandate')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalwhinscan),
      expression: "addmodalwhinscan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('WH INscan date'),
      "name": "addmodalwhinscan",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalwhinscan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalwhinscan = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.sladatetime')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalsladatetime),
      expression: "addmodalsladatetime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ('SLA date'),
      "name": "addmodalsladatetime",
      "autocomplete": "nope",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addmodalsladatetime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalsladatetime = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalbreachreason),
      expression: "addmodalbreachreason"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "addmodalbreachreason",
      "placeholder": _vm.addmodalbreachreason ? '' : 'Breach Reason'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addmodalbreachreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('slaBreachReport.breachreason')))]), _vm._v(" "), _vm._l((_vm.breachreasonslist), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason.breachreason
      }
    }, [_vm._v("\n                    " + _vm._s(reason.breachreason))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('slaBreachReport.comments')))]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-window-maximize'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addmodalcomments),
      expression: "addmodalcomments"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.addmodalcomments ? null : 'Comments',
      "name": "addmodalcomments",
      "autocomplete": "nope"
    },
    domProps: {
      "value": (_vm.addmodalcomments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addmodalcomments = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [(_vm.categoryaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.addbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" "), (_vm.categoryaction == 'view') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.editbreachreason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.updateBtn')))]) : _vm._e(), _vm._v(" "), _vm._v("\n             "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])], 1)])]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e4f2b90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4f2b90","hasScoped":true}!./src/views/components/slabreach/slabreach.component.html
// module id = 2173
// module chunks = 0